import React from 'react';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { getArchiveIcon } from '@isyc-react/archives/view/tools';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { useArchiveDownloadById, ViewArchiveByIdModal } from '@isyc-react/form-file/modules/view/archive-id';
import { IconButtonTransparent } from '@isyc-react/form/modules/button/icon';
import clsx from 'clsx';
import { namespaces } from 'i18n/i18n.constants';
import { useTranslation } from 'react-i18next';
import { TableClient } from '@isyc-react/table/modules';
import { DocumentalTypologyResult } from '@isyc-react/types';
const ValidationResult = props => {
    const { result } = props;
    switch (result) {
        case DocumentalTypologyResult.TYPOLOGY_RESULT_IN_PROGRESS:
            return (React.createElement("div", { className: 'text-center' },
                React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'see-status' }, "En cours") },
                    React.createElement("i", { className: 'mdi mdi-clock font-size-22 text-secondary' }))));
        case DocumentalTypologyResult.TYPOLOGY_RESULT_VALID:
            return (React.createElement("div", { className: 'text-center' },
                React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'see-status' }, "Valide") },
                    React.createElement("i", { className: 'mdi mdi-check-circle font-size-22 text-success' }))));
        case DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID:
            return (React.createElement("div", { className: 'text-center' },
                React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'see-status' }, "Invalide") },
                    React.createElement("i", { className: 'mdi mdi-close-circle font-size-22 text-danger' }))));
        case DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO:
        default:
            return (React.createElement("div", { className: 'text-center' },
                React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'see-status' }, "Sans validation") },
                    React.createElement("i", { className: 'mdi mdi-file-document font-size-22 text-muted' }))));
    }
};
export const DocGroupCompleted = props => {
    const { completed } = props;
    const { t } = useTranslation(namespaces.common);
    const columns = React.useMemo(() => [
        {
            Header: 'Document',
            id: 'document',
            accessor: item => item.archiveName,
            minWidth: 120,
            disableSortBy: true,
            disableGroupBy: true,
            aggregate: 'uniqueCount',
            Aggregated: ({ value }) => React.createElement("div", { className: 'text-center' },
                value,
                " fichiers diff\u00E9rents"),
            Cell: ({ value }) => {
                const classes = getArchiveIcon(value);
                return (React.createElement("div", { className: 'd-flex align-items-center justify-content-start' },
                    React.createElement("i", { className: clsx(classes.icon, 'font-size-22 me-2') }),
                    React.createElement("span", null, value)));
            },
        },
        {
            Header: 'Groupe',
            accessor: 'name',
            minWidth: 120,
            aggregate: 'uniqueCount',
            Aggregated: ({ value }) => React.createElement("div", { className: 'text-center' },
                value,
                " groupes documentaires diff\u00E9rents"),
            Cell: ({ value }) => React.createElement("div", { className: 'text-center' }, value),
        },
        {
            Header: 'Typologie',
            accessor: 'tName',
            minWidth: 120,
            aggregate: 'uniqueCount',
            Aggregated: ({ value }) => React.createElement("div", { className: 'text-center' },
                value,
                " typologies diff\u00E9rentes"),
            Cell: ({ value }) => React.createElement("div", { className: 'text-center' }, value),
        },
        {
            Header: 'Statut',
            accessor: 'result',
            minWidth: 120,
            aggregate: 'uniqueCount',
            disableSortBy: true,
            Aggregated: ({ value }) => React.createElement("div", { className: 'text-center' },
                value,
                " \u00E9tats diff\u00E9rents"),
            Cell: ({ value }) => (React.createElement("div", { className: 'text-center' },
                React.createElement(ValidationResult, { result: value }))),
        },
        {
            Header: '',
            id: 'actions',
            accessor: item => item,
            minWidth: 120,
            disableSortBy: true,
            disableGroupBy: true,
            disableFilters: true,
            freeze: true,
            Aggregated: () => React.createElement(React.Fragment, null),
            Cell: (props) => {
                const { value: data } = props;
                const [show, setShow] = React.useState(false);
                const [download, { error, loading }] = useArchiveDownloadById(data.archiveId);
                return (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                    React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'see-title' },
                            "Voir ",
                            data.archiveName) },
                        React.createElement(IconButtonTransparent, { ripple: '#8e8e8e', onClick: () => {
                                setShow(true);
                            } },
                            React.createElement("i", { className: 'mdi mdi-eye' }))),
                    React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, overlay: React.createElement(Tooltip, { id: 'download-title' }, "T\u00E9l\u00E9charger le fichier") },
                        React.createElement(IconButtonTransparent, { ripple: '#8e8e8e', disabled: loading, onClick: () => {
                                download();
                            } },
                            React.createElement("i", { className: 'mdi mdi-download' }))),
                    show && (React.createElement(ViewArchiveByIdModal, { show: show, id: data.archiveId, name: data.archiveName, onChange: setShow }))));
            },
        },
    ], []);
    const data = React.useMemo(() => {
        const result = [];
        completed.forEach(c => {
            c.requests.forEach(req => {
                const documentsEdm = req.documentsEdm.sort((a, b) => b.id - a.id);
                // TODO show every documentEdm or only the first or latest ... ??
                // if (documentsEdm[0]) {
                //   result.push({
                //     name: c.name,
                //     code: c.code,
                //     tName: req.tName,
                //     tCode: req.tCode,
                //     status: req.status,
                //     result: req.result,
                //     archiveId: documentsEdm[0].archiveId,
                //     archiveName: documentsEdm[0].archiveName,
                //   })
                // }
                documentsEdm.forEach(documentEdm => {
                    result.push({
                        name: c.name,
                        code: c.code,
                        tName: req.tName,
                        tCode: req.tCode,
                        status: req.status,
                        result: req.result,
                        archiveId: documentEdm.archiveId,
                        archiveName: documentEdm.archiveName,
                    });
                });
            });
        });
        result.sort((a, b) => a.archiveId - b.archiveId);
        return result;
    }, [completed]);
    return (React.createElement(Slug, { delay: 100, from: { opacity: 0, transform: 'translate3d(-80px,0px,0)' } },
        React.createElement("div", { className: 'card-body p-0' }, data.length === 0 ? (React.createElement("p", { className: 'text-center text-muted mb-0' }, "Aucun fichier n'est encore termin\u00E9")) : (React.createElement(TableClient, { defaultFilterType: 'placeholderLabel', summary: 'Uploaded documents', data: data, columns: columns, initial: {
                pagination: {
                    size: 50,
                },
            }, options: {
                pagination: {
                    sizes: [25, 50, 100, 150],
                },
            } })))));
};
